import PropTypes from 'prop-types';
import clsx from 'clsx';
import Container from '@/components/Container';

const defaultProps = {
  className: null,
  sectionTitle: null,
  spacing: 'py-10 lg:py-20',
};

const propTypes = {
  className: PropTypes.string,
  sectionTitle: PropTypes.string,
  spacing: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default function MarketingSection({
  className,
  sectionTitle,
  spacing,
  children,
}) {
  const hasTitle = sectionTitle !== null;

  return (
    <div className={clsx(spacing, className)}>
      <Container className="space-y-10 lg:space-y-20">
        {hasTitle && (
          <div className="flex justify-center text-center max-w-screen-md mx-auto">
            <h2 className="font-semibold text-2xl lg:text-4xl lg:font-bold tracking-tight">
              <div className="leading-normal">
                {sectionTitle}
              </div>
            </h2>
          </div>
        )}
        <div className="flex flex-col">
          {children}
        </div>
      </Container>
    </div>
  );
}

MarketingSection.defaultProps = defaultProps;
MarketingSection.propTypes = propTypes;
